export const BACKEND_URL: string = 'https://ruch.synapto.ch/api';
